// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconUncategorizedPath = 'M14.52 7.504h2v-.097c.001-.21.135-.4.291-.456 1.581-.48 2.568-2.072 2.278-3.783-.344-1.36-1.472-2.36-3.016-2.623a3.564 3.564 0 0 0-2.96.766 3.568 3.568 0 0 0-1.279 2.432l1.992.182c.039-.423.24-.805.566-1.077a1.597 1.597 0 0 1 1.158-.362c.044.005.087.013.177.029l.086.015c.678.115 1.19.547 1.321 1.048.108.643-.282 1.27-.947 1.473a2.507 2.507 0 0 0-1.667 2.353v.1Zm2.48 2.5a1.5 1.5 0 1 0-3 .001 1.5 1.5 0 0 0 3 0Zm-12-5.5a2.503 2.503 0 0 0-2.5 2.5c0 1.378 1.121 2.5 2.5 2.5 1.378 0 2.5-1.122 2.5-2.5s-1.122-2.5-2.5-2.5Zm0 7a4.506 4.506 0 0 1-4.5-4.5c0-2.48 2.02-4.5 4.5-4.5 2.481 0 4.5 2.02 4.5 4.5 0 2.481-2.019 4.5-4.5 4.5Zm8.317 5H8.684L11 13.234l2.317 3.27Zm-8.5 2h12.367L11 9.774l-6.183 8.73Z';
var IconUncategorized = baseIcon('IconUncategorized', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconUncategorizedPath
});
export default IconUncategorized;
//# sourceMappingURL=index.js.map